import React from 'react'
import { Button } from 'primereact/button';

const BotonesPrincipal = ({ openNew, confirmDeleteSelected, selectedProducts, products }) => {
    //--------------------| Exportar PDF |--------------------
    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                doc.autoTable({
                    columns: [                                       // CAMBIAR...
                        { header: 'Nombre', dataKey: 'nombreRazon' },
                        { header: 'Apellidos', dataKey: 'apellidos' },
                        { header: 'Rfc', dataKey: 'rfc' },
                        { header: 'Email', dataKey: 'email' },
                        { header: 'Estatus', dataKey: 'estatus' },
                        { header: 'Licencia', dataKey: 'licencia' },
                    ],
                    body: products,                                  // Registros de BD
                    margin: { top: 35 },
                    styles: {
                        overflow: 'linebreak',
                        fontSize: 8,
                        cellWidth: 'wrap',
                        halign: 'center',
                        valign: 'middle',
                    },
                    didDrawPage: function (data) {
                        doc.text("Catalogo clientes", 20, 30);            // CAMBIAR...
                    }
                })

                const fecha = new Date().getTime()                    // Fecha en tiempo real
                doc.save(`Clientes_export_${fecha}.pdf`);             // template string  /   CAMBIAR...
            })
        })
    }

    //--------------------| Exportar Excel |--------------------
    //---> Funcion Principal
    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(products);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Clientes');                 // CAMBIAR...
        });
    }

    //---> Guardar datos en Excel
    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });
                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    }


    return (
        <div className='my-4'>
            <div className="md:flex md:justify-content-between ml-6 md:mx-0">
                <div>
                    <Button label="Nuevo" icon="pi pi-plus" className="p-button-success m-2 w-10rem" onClick={openNew} />
                    <Button label="Desactivar" icon="pi pi-ban" className="p-button-danger m-2 w-10rem" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} />
                </div>
                <div>
                    <Button
                        label="Excel"
                        icon="pi pi-file-excel"
                        className="p-button-success m-2 w-10rem"
                        onClick={exportExcel} disabled={products.length < 1}
                    />
                    <Button
                        label="PDF"
                        icon="pi pi-file-pdf"
                        className="p-button-danger m-2 w-10rem"
                        onClick={exportPdf} disabled={products.length < 1}
                    />
                </div>
            </div>
        </div>
    )
}

export default BotonesPrincipal
